"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var easeOutBounce_1 = require("./easeOutBounce");
exports.easeInOutBounce = function (x) { return x < 0.5
    ? (1 - easeOutBounce_1.easeOutBounce(1 - 2 * x)) / 2
    : (1 + easeOutBounce_1.easeOutBounce(2 * x - 1)) / 2; };
//# sourceMappingURL=easeInOutBounce.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/vendor/just-curves/curves/easeInOutBounce.js
// module id = 172
// module chunks = 35783957827783 127651196306611 162898551421021